import { useCallback } from "react";
import { useVisitorInfo } from "@/common/hooks";
import "./ExploreNicheNavigation.scss";
import { IItemList, Select } from "@/components/core/Select";
import { onOpenCreateNichePopup } from "@/components/popup-dispatcher/PopupDispatcher";
import { NICHE_SORT_ORDER_OPTIONS } from "@/common/utils/nicheSortOptions";
import { showNotification } from "@/components/alerts/Notifications";
import { Button } from "@/components/buttons/Button";

interface IProps {
  order: string;
  sort: string;
  onSortChange: (order: string, sort: string) => void;
  sortOptions: IItemList[];
}

export const ExploreNicheNavigation = ({ order, sort, onSortChange, sortOptions }: IProps) => {
  const currentUser = useVisitorInfo();

  const onClickCreateNiche = useCallback(() => {
    if (import.meta.env.MODE === "production") {
      // TODO: temp notification until niche creation is back
      showNotification({
        variant: "info",
        title: "Niche Creation is on hold",
        description: "Niche creation is taking a short break while we make some exciting improvements. See our FAQs for more info.",
        actionButton: {
          title: "Go to the FAQ",
          onClick: () => window.open("https://help.redgifs.com/hc/en-us/sections/33780290962193-Niche-Creation-Pause", "_blank", "noopener,noreferrer")
        },
      });
    } else {
      onOpenCreateNichePopup();
    }
  }, []);

  const handleOrderChange = (value: string | null) => {
    if (!value) {
      return;
    }

    if (value === "subscribers" || value === "posts") {
      onSortChange(value, "desc");
    } else if (value === "name") {
      onSortChange("name", "asc");
    }
  };

  const handleSortChange = (value: string | null) => {
    if (!value) {
      return;
    }

    onSortChange("name", value);
  };

  return (
    <div className="nicheTopNav">
      <Select
        label="Sort by"
        value={order}
        list={sortOptions}
        onChange={handleOrderChange}
      />

      {order === "name" && (
        <Select
          label="Order"
          value={sort}
          list={NICHE_SORT_ORDER_OPTIONS}
          onChange={handleSortChange}
        />
      )}

      {currentUser && (
        <div className="nicheCreateBtn">
          <Button variant="secondary" size="xs" onClick={onClickCreateNiche}>Create Niche</Button>
        </div>
      )}
    </div>
  );
};
